var DbDoc, MDA_TABLE_PREFIX, mdaTableDocShape,
  __slice = [].slice;

DbDoc = require('lib/db_docs/db_doc');

mdaTableDocShape = require('lib/db_docs/doc_shapes/mda_table_doc_shape');

MDA_TABLE_PREFIX = require('lib/doc_prefixes').mdaTable;

module.exports = DbDoc(mdaTableDocShape, {
  dbSetup: {
    idPrefix: MDA_TABLE_PREFIX
  },
  methods: {
    addTopic: function(topicId) {
      return this.updateAt('topics')(function(topics) {
        return _.chain(topics != null ? topics : []).union([topicId]).uniq().value();
      });
    },
    removeTopic: function(topicId) {
      return this.updateAt('topics')(function(topics) {
        return _.without(topics != null ? topics : [], topicId);
      });
    },
    updateContent: function(newContent) {
      return this.updateAt('content')(function(oldContent) {
        var newContentWithoutSelection, oldContentWithoutSelection;
        oldContentWithoutSelection = _.omit(oldContent, 'selection');
        newContentWithoutSelection = _.omit(newContent, 'selection');
        if (_.isEqual(oldContentWithoutSelection, newContentWithoutSelection)) {
          return oldContent;
        } else {
          return newContent;
        }
      });
    },
    updateName: function(newName) {
      return this.setAt('name')(newName);
    },
    addAnnotationReply: function(annotationId, data) {
      var parentAnnotationId;
      parentAnnotationId = data.parentId;
      return this.updateAt('content', 'annotations')(function(annotations) {
        var newParent, parentAnnotation;
        parentAnnotation = annotations[data.parentId];
        newParent = R.assoc('replies', (parentAnnotation.replies || []).concat(annotationId), parentAnnotation);
        return R.compose(R.assoc(annotationId, data), R.assoc(parentAnnotationId, newParent))(annotations);
      });
    },
    updateAnnotation: function(annotationId, data) {
      return this.updateAt('content', 'annotations', annotationId)(R.mergeRight(R.__, data));
    },
    removeAnnotation: function(annotation) {
      return this.updateAt('content', 'annotations')(function(annotations) {
        var newReplies, repliesLens;
        repliesLens = R.lensPath([annotation.parentId, 'replies']);
        newReplies = R.without(annotation.id, R.view(repliesLens, annotations) || []);
        return R.compose(R.omit([annotation.id].concat(__slice.call(R.pluck('id', annotation.replies)))), annotation.parentId ? R.set(repliesLens, newReplies) : R.identity)(annotations);
      });
    }
  }
});
